import {IntegrationMap, IntegrationModule, TelemetryPayload} from 'TelemetryTypes';
import {TelemetryEventName} from 'TelemetryConstants';
import {AWSBlacklistConfig} from './AWSBlacklistConfig';
import {NativeModules} from 'react-native';

const SKZReactUserManager = NativeModules.SKZReactUserManager;

const trackAWSEvent = (event: TelemetryEventName, payload: TelemetryPayload) => {
  try {
    if (SKZReactUserManager && typeof SKZReactUserManager.trackEventForUser === 'function') {
      const stringifiedPayload = JSON.stringify(payload);
      SKZReactUserManager.trackEventForUser(event, {result: stringifiedPayload}, {});
    } else {
      console.warn(
        'SKZReactUserManager not properly initialized or trackEventForUser method not available'
      );
    }
  } catch (error) {
    console.error('Error calling SKZReactUserManager.trackEventForUser:', error);
  }
};

// Create handlers for all telemetry events except blacklisted ones
let handlers: IntegrationMap = {};

Object.values(TelemetryEventName).forEach((eventName) => {
  if (!AWSBlacklistConfig.includes(eventName as any)) {
    handlers[eventName] = (payload: TelemetryPayload) => {
      trackAWSEvent(eventName, payload);
    };
  }
});

export const AWSIntegration: IntegrationModule = {
  enabled: true,
  handlers,
};
